import { useTranslation } from 'react-i18next'

import { ConfirmationModal } from '../../Confirmation'
import { FileErrorTooLargeModalContent } from '../FileErrorTooLargeModalContent'

function FileErrorTooLargeModal({ files, sizeLimit, onConfirm }) {
  const { t } = useTranslation()

  return (
    <ConfirmationModal
      actionButtonsProps={{
        Cancel: null,
        submitText: t('Modal.OkBtnKey'),
      }}
      description={
        <FileErrorTooLargeModalContent files={files} sizeLimit={sizeLimit} />
      }
      onClose={onConfirm}
      onSubmit={onConfirm}
    />
  )
}

export default FileErrorTooLargeModal
